
export const CC_EMAILS = [
  "rayapu00@rediffmail.com",
  "rayikaur@rediffmail.com"
];

export const BACKEND_APP_URL = "https://brandsonmove-api-34ffd7d71b42.herokuapp.com"
